/* eslint-disable camelcase */
import TransportationClient from '@/api/TransportationClient';
import TransportationGatewayClient from '@/api/TransportGatewayClient';
import keysToCamelCase from '@/utilities/keysToCamelCase';

const defaultState = {
  applicableServiceTypes: [],
  vehicleInfo: {
    vin: '',
    make: '',
    model: '',
    year: '',
    weight: '',
    trim: '',
    class: '',
    activeRequestAssociated: false,
  },
};

const mutations = {
  setApplicableServiceTypes(state, serviceTypes) {
    state.applicableServiceTypes = serviceTypes;
  },
  setVehicleInfo(state, vehicleInfo) {
    state.vehicleInfo = vehicleInfo;
  },
  resetVinState(state) {
    // Reset the entire state object
    Object.assign(state, defaultState);
  },
};

const actions = {
  async decodeVin({ rootGetters, commit }, vin) {
    const api = new TransportationClient(rootGetters.currentUser);

    // make api call here to validate VIN
    const { data } = await api.getDecodedVin(vin);

    // Map data to use camelCase instead of snake_case
    const mappedData = keysToCamelCase(data.data);

    commit('setVehicleInfo', mappedData);

    return mappedData;
  },

  resetVinState({ commit }) {
    commit('resetVinState');
  },

  async checkoutOptions({ commit }, payload) {
    const api = new TransportationGatewayClient();

    const { data } = await api.getCheckoutOptions(payload);
    const [vehicle] = data.data;

    // We should change the behavior in the future for MVO
    commit('setVehicleInfo', vehicle.vinDecodedResponse);
    commit('setApplicableServiceTypes', vehicle.applicableServiceTypes);

    return data;
  },
};

const getters = {
  getVehicleInfo: (state) => () => state.vehicleInfo,
};

export default {
  state: defaultState,
  mutations,
  actions,
  getters,
};
